import { render, staticRenderFns } from "./SelectPlans.vue?vue&type=template&id=cee05344&lang=pug"
import script from "./SelectPlans.vue?vue&type=script&lang=js"
export * from "./SelectPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports